export default (fileName: string) =>
  fileName.replace(/([0-9]+)-([0-9]+)\s-\s/, '').replace(/\.[a-zA-Z]+$/, '');
